// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// init Swiper:
const swiper = new Swiper(".added-value-swiper", {
  // Optional parameters
  direction: "horizontal",
  slidesPerView: 1,
  spaceBetween: 30,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
      slidesPerGroup: 3,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 3,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // configure Swiper to use modulesm
  modules: [Navigation, Pagination],
});

// swiper for client

new Swiper(".client-swiper", {
  direction: "horizontal",
  slidesPerView: 2,
  spaceBetween: 30,
  centeredSlides: true,
  breakpoints: {
    1024: {
      slidesPerView: 2,
      centeredSlides: true,
      allowTouchMove: false,
    },
  },
  modules: [Pagination],
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const keyfeatureSlider = new Swiper(".connected-feature-swiper", {
  slidesPerView: 2.25,
  watchSlidesProgress: true,
  freeMode: true,
  breakpoints: {
    768: {
      slidesPerView: 3.5,
    },
    1024: {
      slidesPerView: 6,
    },
  },
  spaceBetween: 0,
  modules: [Pagination],
  pagination: {
    clickable: true,
  },
});

new Swiper(".key-feature-swiper", {
  spaceBetween: 20,
  thumbs: {
    swiper: keyfeatureSlider,
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
  },
  modules: [Thumbs, Pagination, Navigation],
});

new Swiper(".faq-swiper", {
  modules: [Navigation, Pagination],
  slidesPerView: 2, // Show 2 slides at a time on mobile
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 6,
      spaceBetween: 28,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

new Swiper(".blog-swiper", {
  direction: "horizontal",
  slidesPerView: 1.5,
  spaceBetween: 10,
  breakpoints: {
    640: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 5.5,
    },
  },
});
